import React, { useState } from "react";
import CustomFileInput from "./CustomFileInput";
import Loader from "../loading";
import axios from "axios";
import Terms from "../terms";
// const init_state = {
//   isUploaded: false,
//   successMsg: "",
//   errorMsg: "",
// };

const API_URL = process.env.REACT_APP_BaseApi_URL;

const SavingsAccount = ({
  accountName,
  customerId,
  navigation,
  globalState,
  entire,
  accountType,
  FullName,
  formData,
  setFormData,
}) => {
  // const [formData, setFormData] = useState({
  //   utility: init_state,
  //   passportPhotograpgh: init_state,
  //   signature: init_state,
  //   // mandateCard: init_state,
  //   isUploading: false,
  // });

  const [chek, setChek] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  // console.log(formData)
  const { isUploading, ...rest } = formData;
  const data = JSON.stringify(entire);
  // console.log({ data, accountType });
  // console.log(formData)
  // const allFieldsAreValid = Object.values(rest).every(
  //   ({ isUploaded }) => isUploaded
  // );
  const allFieldsAreValid =
    formData?.utility?.isUploaded &&
    formData?.signature?.isUploaded &&
    formData?.passportPhotograpgh?.isUploaded;

  const handleCheck = (e) => {
    setChek(e.target.checked);
  };

  const handleClick = () => {
    console.log("here");
    setOpen(true);
  };

  const { previous, go } = navigation;

  const handleMySubmit = async () => {
    const _formData = new FormData();
    setIsLoading(true);
    if (allFieldsAreValid) {
      const payload = {
        utility: formData?.utility?.meta,
        passportPhotograpgh: formData?.passportPhotograpgh?.meta,
        signature: formData?.signature?.meta,
        mandateCard: formData?.mandateCard?.meta,
        means_of_id: globalState?.formData?.means_of_id?.meta,
      };
      const reference = sessionStorage.getItem("reference");
      _formData.append(
        "identity",
        globalState?.formData?.means_of_id?.fileName,
        globalState?.formData?.means_of_id?.fileName?.name
      );
      _formData.append(
        "utility",
        formData?.utility?.fileName,
        formData?.utility?.fileName?.name
      );
      _formData.append(
        "passport",
        formData?.passportPhotograpgh?.fileName,
        formData?.passportPhotograpgh?.fileName?.name
      );
      _formData.append(
        "signature",
        formData?.signature?.fileName,
        formData?.signature?.fileName?.name
      );
      _formData.append("data", data);

      for (const key in entire) {
        const value = entire[key];

        // Skip if value is null, undefined, or empty string
        if (value !== null && value !== undefined && value !== "") {
          _formData.append(key, value);
        }
      }
      _formData.append("requestId", `${reference}`);
      
      setError("");
      try {
        const accessToken = sessionStorage.getItem("verifyTokenAccessToken");

        if (!accessToken) {
          throw new Error("No access token found in sessionStorage");
        }
        const res = await axios.post(
          API_URL + "/individual_account_api",
          _formData,
          {
            timeout: 180000,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (res?.data?.result?.ResponseCode === "00") {
          setIsLoading(false);
          sessionStorage.setItem("deetsTitle", entire.title);
          sessionStorage.setItem("deets", JSON.stringify(res?.data?.result));

          go("success");
        } else {
          setError(
            <p className="text-danger">{`${res?.data?.result?.ResponseDetInfo}, please try agin later`}</p>
          );
        }
      } catch (error) {
        setError(
          <p className="text-danger">{`${
            error?.response?.data?.message || error?.message || "An error occurred"
          }`}</p>
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  const payload = (idCardName) => {
    return [
      ["AccountName", accountName],
      ["customerId", customerId],
      ["idCardName", idCardName],
    ];
  };

  // console.log({ formData });

  return (
    <>
      <CustomFileInput
        state={formData?.utility}
        setState={setFormData}
        id="utility"
        objKey="utility"
        imageType="AllFileTypes"
        payload={payload("utility")}
        label="Utility"
        // isUploading={formData.isUploading}
      />

      <CustomFileInput
        state={formData?.passportPhotograpgh}
        setState={setFormData}
        id="passportPhotograpgh"
        objKey="passportPhotograpgh"
        imageType="AllFileTypes"
        payload={payload("passportPhotograpgh")}
        label="PassportPhotograpgh"
        // isUploading={formData.isUploading}
      />

      <CustomFileInput
        state={formData?.signature}
        setState={setFormData}
        id="signature"
        objKey="signature"
        imageType="AllFileTypes"
        payload={payload("signature")}
        label={"Signature"}
        // isUploading={formData.isUploading}
      />
      {error}
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          className=""
          style={{
            marginLeft: "",
          }}
        >
          <input
            style={{
              marginRight: "5px",
            }}
            type="checkbox"
            required={true}
            checked={chek}
            onChange={handleCheck}
          />
          I Agree to the
          <button
            //  onClick={() => console.log("true")}
            type="button"
            style={{
              color: "#FDB815",
              backgroundColor: "white",
              textDecoration: "underline",
              border: "none",
            }}
            onClick={handleClick}
          >
            {" "}
            Terms & Conditions
          </button>
        </div>
      </div>

      <div className="row mt-5 col-md-9">
        {!allFieldsAreValid && (
          <div className="col-sm-6">
            <div className="form-group">
              <button
                style={{
                  backgroundColor: "#354052",
                  color: "white",
                  minHeight: "60px",
                  maxHeight: "160px",
                  maxWidth: "25%",
                }}
                className={`form-control bg-grey input`}
                // onClick={() => console.log("I am clicked for previous")}
                onClick={previous}
              >
                Previous
              </button>
            </div>
          </div>
        )}

        {allFieldsAreValid && (
          <div className="col-sm-6">
            <div className="form-group">
              <button
                style={{
                  backgroundColor: "#354052",
                  color: "white",
                  minHeight: "60px",
                  maxHeight: "160px",
                  maxWidth: "25%",
                }}
                className={`form-control ${
                  !chek ? "opacity-25 disabled-button" : "bg-grey input"
                } `}
                onClick={handleMySubmit}
                disabled={!chek || isLoading}
              >
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
      <Terms showTerm={open} handleClose={handleClose} />
      {/* <Selfie
        showSelfie={showSelfie}
        handleClose={handleCloseSelfie}
        SubmitSelfie={SubmitSelfie}
      /> */}
      {isLoading ? (
        <Loader text="Creating Account" bgColor="rgba(0,0,0,0.12)" />
      ) : null}
    </>
  );
};

export default SavingsAccount;
